import React, {useState, useRef} from 'react';

function Tab({title, url, currentTabIndex, index}) {
  const iframeRef = useRef(null);

  const [isLoading, setIsLoading] = useState(true);

  const handleLoad = () => {
    setIsLoading(false);
  };

  const show = index === currentTabIndex;

  return (
    <div
      style={{
        display: show ? 'inline-block' : 'none',
        overflow: 'auto',
        width: '100%',
      }}>
      <iframe
        src={url}
        title={title}
        ref={iframeRef}
        onLoad={handleLoad}
        style={{
          width: '100%',
          height: 'calc(100vh - 105px)',
          borderWidth: 0,
        }}
      />
      {isLoading && <div className="loading">Loading...</div>}
    </div>
  );
}

export default Tab;
